import { MouseEvent } from 'react';
import { faEyeSlash } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Button } from '@mui/material';
import classnames from 'classnames';

export const SensitiveContent = ({
  handleHideSensitiveContent,
  isPostCell = false,
}: {
  isPostCell?: boolean;
  handleHideSensitiveContent: (ev: MouseEvent<HTMLButtonElement>) => void;
}) => (
  <Box
    className={classnames(
      'flex justify-between items-center bg-primary-150 rounded-[6px] py-2 pr-2',
      { 'pl-2': isPostCell },
    )}
  >
    <Box className="flex gap-2.5">
      <FontAwesomeIcon
        icon={faEyeSlash}
        className="text-gray-4 w-[18px] h-[14px] self-center"
      />
      <span className="text-gray-4">Sensitive content</span>
    </Box>
    <Button
      variant="text"
      className="text-[#2C3548] font-black text-base"
      onClick={handleHideSensitiveContent}
    >
      Show anyway
    </Button>
  </Box>
);
